import React, { useEffect, useState } from 'react'
import api from '../components/api'
import { dataTableRender } from '../components/functions'

const CombustaoMovel = (props) => {

    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id
    const [resultado, setResultado] = useState()




    async function carregaDados() {

        await api.get(`GHG_DeslocamentoCasaTrabalho4/${adesao_institucional_id}/${ano}`).then((result) => {

            

            setResultado(result.data.map((rs) =>
            
                <tr>
                    <td>{rs.tipoTransporte}</td>
                    <td>{rs.distanciaPercorrida}</td>
                    <td>{rs.diasTrabalhados}</td>
                    <td>{rs.emissoesCO2}</td>
                    <td>{rs.emissoesCO2Total}</td>
                    
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }



    useEffect(() => {

        carregaDados()

    }, [adesao_institucional_id, ano])



    useEffect(() => {


        //dataTableRender('dataTableExampleClima')


    }, [])


    return (

        <div>

            
                <table id="dataTableExampleClima" className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th tyle={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Tipo Transporte
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}> 

                                <center>
                                Dist. Percorrida
                                </center>

                            </th>
                        
                            
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Dias trabalhados
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emiss. CO<sup>2</sup>
                                </center>

                            </th>


                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emiss. CO<sup>2</sup> Total
                                </center>

                            </th>

                            

                            
                        </tr>
                        
                    </thead>
                    <tbody>
                        {resultado}
                    </tbody>
                    
                </table>    



        </div>
    )

}


export default CombustaoMovel